'use strict';
import isFunction from 'lodash/isFunction';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {isCordovaBuild} from '../../../../config/constants';
import {TimePickerController} from '../../TimePickerController';
import template from '../../time-picker.html';
import {TimePickerView} from './TimePickerView';


export class TimePickerComponent extends Component {
  static propTypes = {
    value: T.oneOfType([T.number, T.instanceOf(Date)]),
    onChange: T.func,
    useNative: T.bool,
  };

  static defaultProps = {
    useNative: isCordovaBuild(),
  };

  static $inject = [
    '$modal',
  ];

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleSelectDate = this.handleSelectDate.bind(this);
  }

  handleClick(e) {
    e.stopPropagation();
    TimePickerComponent.dependencies.$modal.show({
      controller: TimePickerController,
      template: template,
      locals: {
        currentValue: this.props.value,
      }
    }).then(this.handleSelectDate);
  }

  handleSelectDate(value) {
    if (isFunction(this.props.onChange)) {
      this.props.onChange(value);
    }
  }

  render() {
    return (
      <TimePickerView
        className={this.props.className}
        useNative={this.props.useNative}
        onClick={this.handleClick}
        onSelectDate={this.props.onChange}
        value={this.props.value}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/android-date-time-pickers/components/TimePicker/TimePickerComponent.js